export const PATIENT_LIST_REQUESTED = 'PATIENT_LIST_REQUESTED';
export const PATIENT_LIST_RECEIVED = 'PATIENT_LIST_RECEIVED';
export const PATIENT_LIST_REQUEST_FAILED = 'PATIENT_LIST_REQUEST_FAILED';

export const PATIENT_REQUESTED = 'PATIENT_REQUESTED';
export const PATIENT_RECEIVED = 'PATIENT_RECEIVED';
export const PATIENT_REQUEST_FAILED = 'PATIENT_REQUEST_FAILED';

export const EMAIL_ACCESS_CODE_REQUESTED = 'EMAIL_ACCESS_CODE_REQUESTED';
export const EMAIL_ACCESS_CODE_SENT = 'EMAIL_ACCESS_CODE_SENT';
export const EMAIL_ACCESS_CODE_FAILED = 'EMAIL_ACCESS_CODE_FAILED';
export const SMS_ACCESS_CODE_REQUESTED = 'SMS_ACCESS_CODE_REQUESTED';
export const SMS_ACCESS_CODE_SENT = 'SMS_ACCESS_CODE_SENT';
export const SMS_ACCESS_CODE_FAILED = 'SMS_ACCESS_CODE_FAILED';
export const RESET_NEW_PATIENT = 'RESET_NEW_PATIENT';

export const SIGNUP_REQUESTED = 'SIGNUP_REQUESTED';
export const SIGNUP_FAILED = 'SIGNUP_FAILED';
export const SIGNUP_COMPLETED = 'SIGNUP_COMPLETED';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';

export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_COMPLETED = 'LOGIN_COMPLETED';

export const LOGOUT_REQUESTED = 'LOGOUT_REQUESTED';
export const LOGOUT_FAILED = 'LOGOUT_FAILED';

export const LOAD_SESSION = 'LOAD_SESSION';
export const CLEAR_SESSION = 'CLEAR_SESSION';



// WEBPACK FOOTER //
// ./src/constants/actions.js